<template>
  <div>
    <div class="m-4"></div>
    <h2>Debugger</h2>
    <div class="m-4"></div>
    <div class="bordered-block">
      <pre class="w-full">{{ data }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-builder-debugger',
  props: ['data'],
};
</script>

<style></style>
